import GoogleTagDataLayer from "app/components/GoogleTagDataLayer/GoogleTagDataLayer";
import TimeSectionTimePhase from "app/components/TimeSectionLivePhase/TimeSectionTimePhase";
import { BetSlipHelper } from "app/helpers/betSlipHelper";
import { EventHelper } from "app/helpers/eventHelper";
import { MarketsHelper } from "app/helpers/marketsHelper";
import {
  competitionListTimeEnum,
  EventStatus,
  MarketTypes,
  RunnerTypes,
  SportsNameType,
} from "app/utils/const";
import cx from "classnames";
import flatten from "lodash/flatten";
import { PureComponent } from "react";
import { connect } from "react-redux";
import { RowHeightHelper } from "../../../../helpers/rowHeightHelper";
import ListRenderLogic from "../../../../logic/listRenderLogic";
import type { EventType } from "../../../../types/eventType";
import AsianEventCellTime from "../AsianEventCellTime/AsianEventCellTime";
import AsianEventIcons from "../AsianEventIcons/AsianEventIcons";
import { AsianEventNameSection } from "../AsianEventNameSection/AsianEventNameSection";
import "./AsianEventCellModal.scss";
import AllPricesLinkOuterContainer from "./components/AllPricesLinkOuterContainer/AllPricesLinkOuterContainer";
import AsianEventMarketsContainer from "./components/AsianEventMarketsContainer/AsianEventMarketsContainer";
import SuspendedTextEvent from "./components/SuspendedTextEvent/SuspendedTextEvent";
//
type Props = {
  event: EventType;
  index: number;
  competitionIndex: number;
  toggleAddRemoveToFavorites: (...args: Array<any>) => any;
  userTimezone: Record<string, any>;
  toggleMarketGraph: (...args: Array<any>) => any;
  showUnsummarizedMarketsModal: boolean;
  searchResultModalActive: boolean;
  setUnsummarizedMarketsModalToOpen: (...args: Array<any>) => any;
  unsetUnsummarizedMarketsModalToOpen: (...args: Array<any>) => any;
  unsummarizedMarketsModalEventId: number;
  closeModal: (...args: Array<any>) => any;
  isEventLoading: boolean;
  updateUnsummarizedMarketsModalEventLoading: (...args: Array<any>) => any;
  unsummarizedMarketsModalEvent: EventType;
  updateUnsummarizedMarketsModalEvent: (...args: Array<any>) => any;
  line: string;
  competitionIsVisible: boolean;
  listSize: number;
  openAsianEventModal: (...args: Array<any>) => any;
  closeAsianEventModal: (...args: Array<any>) => any;
  addBetSlip: (...args: Array<any>) => any;
  selectedMarketType: string;
  displayDraw: boolean;
  translatedMarketName: string;
};
type State = {
  modalOpen: boolean;
  isHovered: boolean;
  hoverClass: string;
};

// Asian event in main list, ie not in a modal
class AsianEventCellModal extends PureComponent<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      isHovered: false,
      hoverClass: "",
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleMouseEnter = () => {
    const { event } = this.props;
    const hasAsianUnavailableClass = event.numberOfMarkets === 0;
    let classNameToAdd = "";
    if (!hasAsianUnavailableClass) {
      if (event["inRunning"]) {
        classNameToAdd = "hover-live";
      } else {
        classNameToAdd = "hover-highlight";
      }
    } else if (hasAsianUnavailableClass) {
      if (event["inRunning"]) {
        classNameToAdd = "hover-live";
      } else {
        classNameToAdd = "hover-highlight";
      }
    }
    this.setState({ hoverClass: classNameToAdd });
  };

  handleMouseLeave = () => {
    this.setState({ hoverClass: "" });
  };
  handleClick() {
    const { event } = this.props;
    this.setState({
      modalOpen: true,
    });

    // Call the setUnsummarizedMarketsModalToOpen action
    this.props.setUnsummarizedMarketsModalToOpen(this.props.event);
  }

  onClickGraph() {
    // Default details in market data graph are for summary handicap market, home team, full time. If no handicap market, show moneyline market, home team, full time.
    let runnerToDisplay: any = {};
    let marketToDisplay = {};
    const eventData = this.props.event;
    const handicapRunners =
      eventData &&
      eventData.marketPeriods &&
      eventData.marketPeriods[0] &&
      eventData.marketPeriods[0].marketTypes &&
      eventData.marketPeriods[0].marketTypes[1] &&
      eventData.marketPeriods[0].marketTypes[1].markets &&
      eventData.marketPeriods[0].marketTypes[1].markets[0] &&
      eventData.marketPeriods[0].marketTypes[1].markets[0].runners &&
      eventData.marketPeriods[0].marketTypes[1].markets[0].runners;

    if (handicapRunners) {
      marketToDisplay = eventData.marketPeriods[0].marketTypes[1].markets[0];
    }

    runnerToDisplay =
      handicapRunners &&
      handicapRunners.find(runner => runner.side === RunnerTypes.HOME);

    if (!handicapRunners) {
      const moneylineRunners =
        eventData &&
        eventData.marketPeriods &&
        eventData.marketPeriods[0] &&
        eventData.marketPeriods[0].marketTypes &&
        eventData.marketPeriods[0].marketTypes[1] &&
        eventData.marketPeriods[0].marketTypes[1].markets &&
        eventData.marketPeriods[0].marketTypes[1].markets[0] &&
        eventData.marketPeriods[0].marketTypes[1].markets[0].runners &&
        eventData.marketPeriods[0].marketTypes[1].markets[0].runners;
      runnerToDisplay =
        moneylineRunners &&
        moneylineRunners.find(runner => runner.side === RunnerTypes.HOME);

      if (moneylineRunners) {
        marketToDisplay = eventData.marketPeriods[0].marketTypes[0].markets[0];
      }
    }

    this.props.toggleMarketGraph({
      eventData,
      runnerToDisplay,
      marketToDisplay,
    });
  }

  // ARCH-85 launch modal
  openModal = (e: Record<string, any>) => {
    e.preventDefault();
    this.props.event.isActive === false &&
      this.props.setUnsummarizedMarketsModalToOpen(this.props.event);
  };
  componentDidUpdate = (prevProps, prevState) => {
    const { event, showUnsummarizedMarketsModal, searchResultModalActive } =
      this.props;

    // ARCH-85
    if (
      !searchResultModalActive &&
      prevProps.unsummarizedMarketsModalEventId === event.id
    ) {
      if (
        prevProps.showUnsummarizedMarketsModal === false &&
        showUnsummarizedMarketsModal === true &&
        this.state.modalOpen === false
      ) {
        this.setState({
          modalOpen: true,
        });
      } else if (
        prevProps.showUnsummarizedMarketsModal === true &&
        showUnsummarizedMarketsModal === false
      ) {
        this.setState({
          modalOpen: false,
        });
      }
    }

    if (prevProps.isEventLoading !== this.props.isEventLoading) {
      this.props.updateUnsummarizedMarketsModalEventLoading(
        this.props.isEventLoading
      );
    }
  };
  addBetSlip = runner => {
    let betSlip = BetSlipHelper.prepareBetSlip(this.props.event, runner);
    this.props.addBetSlip(betSlip);
  };

  hasOpenRunnerWithPrices() {
    const { event } = this.props;

    if (event.marketPeriods && event.marketPeriods.length > 0) {
      const marketTypes = flatten(
        event.marketPeriods.map(mp => mp.marketTypes)
      );
      const markets = flatten(marketTypes.map(mt => mt.markets));
      const runners = flatten(markets.map(m => m.runners));
      const runnersWithPrices = runners.filter(
        r =>
          r != null &&
          r.status === "OPEN" &&
          r["aggregatedPrices"] &&
          r["aggregatedPrices"].length > 0
      );
      return runnersWithPrices && runnersWithPrices.length > 0 ? true : false;
    } else {
      return false;
    }
  }

  getHighestNumberOfMarkets = () => {
    const { event, line } = this.props;
    let highestNumberOfMarkets = 0;

    if (line === competitionListTimeEnum.ALL) {
      event.marketPeriods &&
        event.marketPeriods.forEach(mps => {
          mps.marketTypes &&
            mps.marketTypes.forEach(mp => {
              if (mp.markets && mp.markets.length > highestNumberOfMarkets) {
                highestNumberOfMarkets = mp.markets.length;
              }
            });
        });
    }

    return highestNumberOfMarkets;
  };
  getPlaceHolder = () => {
    const { event, line, competitionIsVisible, competitionIndex, listSize } =
      this.props;
    const hideDetails = ListRenderLogic.hideEventDetails(
      listSize,
      competitionIndex,
      competitionIsVisible
    );

    // If all lines selected and event isn't visible,
    // use placeholder with calculated height
    if (line === competitionListTimeEnum.ALL && !competitionIsVisible) {
      const allLineStyle = {
        height: RowHeightHelper.calculateAllLinesEventHeight(event),
      };
      return <div className="asian-event-placeholder" style={allLineStyle} />;
    } else if (hideDetails) {
      return <div className="asian-event-placeholder" />;
    }
  };

  render() {
    const {
      event,
      index,
      toggleAddRemoveToFavorites,
      userTimezone,
      showUnsummarizedMarketsModal,
      unsummarizedMarketsModalEventId,
      line,
      selectedMarketType,
      displayDraw,
      translatedMarketName,
    } = this.props;

    const isEventLive = EventHelper.isEventLive(event);
    const isCricketEvent = event.sportType === SportsNameType.CRICKET;
    const hasPrices = this.hasOpenRunnerWithPrices();
    const hasAdditionalMarkets =
      event.numberOfAdditionalMarkets > 0 ? true : false;
    const isOutright = MarketsHelper.isOutright(selectedMarketType, null);
    this.getPlaceHolder();

    let highestNumberOfMarkets = this.getHighestNumberOfMarkets();
    return (
      <div
        className={cx(
          {
            "asian-event-background": !event["inRunning"] && index % 2 === 0, // different background colour for alternate rows
          },
          {
            "asian-event-background--alternate":
              !event["inRunning"] && index % 2 !== 0,
          },
          {
            "asian-event-background--live":
              event["inRunning"] && index % 2 === 0,
          },
          {
            "asian-event-background--live-alternate":
              event["inRunning"] && index % 2 !== 0,
          },
          {
            "suspended-event":
              event.status === EventStatus.SUSPENDED ||
              event.status === EventStatus.CLOSED ||
              event.status === EventStatus.GRADED,
          }
        )}
      >
        {event && <SuspendedTextEvent event={event} />}
        <div
          className={cx(
            "asian-event",
            event.status && event.status.toLowerCase(),
            line === "MAIN" && selectedMarketType !== MarketTypes.OUTRIGHT
              ? "main-line"
              : "",
            isOutright ? "asian-event--outright" : "",
            `asian-event-highlight${
              event.numberOfMarkets === 0
                ? " asian-event-highlight--prevent"
                : ""
            }`,
            this.state.hoverClass
          )}
          id={event.id}
        >
          <div className="asian-event__date">
            {isCricketEvent && isEventLive ? (
              <div className="asian-event__time-section">
                <TimeSectionTimePhase />
              </div>
            ) : (
              <AsianEventCellTime eventData={event} timezone={userTimezone} />
            )}
          </div>
          <GoogleTagDataLayer
            googleTagClickId={"asianEventSummary"}
            dlvEventName={"DLV-Asian-Event-Summary"}
          >
            <div
              className={`asian-event-highlight${
                event.numberOfMarkets === 0
                  ? " asian-event-highlight--prevent"
                  : ""
              }`}
              onClick={this.handleClick}
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
            >
              <AsianEventNameSection
                event={event}
                marketType={selectedMarketType}
                displayDraw={displayDraw}
              />
              <div className="asian-icons">
                <AsianEventIcons
                  event={event}
                  toggleAddRemoveToFavorites={toggleAddRemoveToFavorites}
                  onClickGraph={this.onClickGraph.bind(this)}
                />
              </div>
            </div>
          </GoogleTagDataLayer>
          <AsianEventMarketsContainer
            showUnsummarizedMarketsModal={showUnsummarizedMarketsModal}
            unsummarizedMarketsModalEventId={unsummarizedMarketsModalEventId}
            event={event}
            hasPrices={hasPrices}
            hasAdditionalMarkets={hasAdditionalMarkets}
            highestNumberOfMarkets={highestNumberOfMarkets}
            addBetSlip={this.addBetSlip}
            translatedMarketName={translatedMarketName}
          />
          {!isOutright && (
            <AllPricesLinkOuterContainer
              event={event}
              openModal={
                event["numberOfAdditionalMarkets"] > 0 || event.isActive
                  ? e => this.openModal(e)
                  : null
              }
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userTimezone: state.userModel.timezone,
  showUnsummarizedMarketsModal:
    state.competitionListModel.showUnsummarizedMarketsModal,
  searchResultModalActive: state.competitionListModel.searchResultModalActive,
  unsummarizedMarketsModalEventId:
    state.competitionListModel.unsummarizedMarketsModalEventId,
  unsummarizedMarketsModalEvent:
    state.competitionListModel.unsummarizedMarketsModalEvent,
  line: state.asianCompetitionListFiltersModel.line,
  selectedMarketType: state.sportsSelectionListModel.selectedMarketType,
  displayDraw: state.sportsSelectionListModel.displayDraw,
  selectedMarketName: state.sportsSelectionListModel.selectedMarketName,
  translatedMarketName: state.sportsSelectionListModel.translatedMarketName,
});

const mapDispatchToProps = dispatch => ({
  toggleMarketGraph: (eventData, runner, market) => {
    dispatch.marketDataGraphModel.openMarketGraphModal(
      eventData,
      runner,
      market
    );
  },
  setUnsummarizedMarketsModalToOpen: eventId => {
    dispatch.competitionListModel.setUnsummarizedMarketsModalToOpen(eventId);
  },
  unsetUnsummarizedMarketsModalToOpen: () => {
    dispatch.competitionListModel.unsetUnsummarizedMarketsModalToOpen();
  },
  updateUnsummarizedMarketsModalEvent: event => {
    dispatch.competitionListModel.updateUnsummarizedMarketsModalEvent(event);
  },
  updateUnsummarizedMarketsModalEventLoading: eventLoading => {
    dispatch.competitionListModel.updateUnsummarizedMarketsModalEventLoading(
      eventLoading
    );
  },
  addBetSlip: (betSlip: EventType) =>
    dispatch.betSlipListModel.addBetSlip(betSlip),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AsianEventCellModal) as any;
